module.exports = __webpack_public_path__ + "static/media/matnrrd_3-578w.e6022901.png";